!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define("conditional-fields", [], e) : "object" == typeof exports ? exports["conditional-fields"] = e() : t["conditional-fields"] = e();
}(window, function () {
  return function (t) {
    var e = {};

    function n(r) {
      if (e[r]) return e[r].exports;
      var o = e[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }

    return n.m = t, n.c = e, n.d = function (t, e, r) {
      n.o(t, e) || Object.defineProperty(t, e, {
        enumerable: !0,
        get: r
      });
    }, n.r = function (t) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    }, n.t = function (t, e) {
      if (1 & e && (t = n(t)), 8 & e) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var r = Object.create(null);
      if (n.r(r), Object.defineProperty(r, "default", {
        enumerable: !0,
        value: t
      }), 2 & e && "string" != typeof t) for (var o in t) n.d(r, o, function (e) {
        return t[e];
      }.bind(null, o));
      return r;
    }, n.n = function (t) {
      var e = t && t.__esModule ? function () {
        return t.default;
      } : function () {
        return t;
      };
      return n.d(e, "a", e), e;
    }, n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, n.p = "/", n(n.s = "./src/index.js");
  }({
    "./src/app.js": function (t, e, n) {
      "use strict";

      var r = "data-rules",
          o = ["change", "blur", "focus", "keydown", "keypress", "keyup"],
          i = function (t) {
        return t.style.display = "block";
      },
          u = function (t) {
        return t.style.display = "none";
      },
          c = function (t) {
        var e = void 0;

        try {
          e = JSON.parse(t);
        } catch (t) {
          e = [];
        }

        return e;
      },
          a = function (t, e) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return function (t, e) {
          var n = [],
              r = !0,
              o = !1,
              i = void 0;

          try {
            for (var u, c = t[Symbol.iterator](); !(r = (u = c.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0);
          } catch (t) {
            o = !0, i = t;
          } finally {
            try {
              !r && c.return && c.return();
            } finally {
              if (o) throw i;
            }
          }

          return n;
        }(t, e);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
          f = function (t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
            r = e.filter(function (e) {
          return (0, e.check)(t);
        });
        return new (0, a(r, 1)[0].Element)(t, n);
      },
          l = function (t, e) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return function (t, e) {
          var n = [],
              r = !0,
              o = !1,
              i = void 0;

          try {
            for (var u, c = t[Symbol.iterator](); !(r = (u = c.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0);
          } catch (t) {
            o = !0, i = t;
          } finally {
            try {
              !r && c.return && c.return();
            } finally {
              if (o) throw i;
            }
          }

          return n;
        }(t, e);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
          s = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];

          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }

        return t;
      },
          p = function (t, e) {
        if (Array.isArray(t)) return t;
        if (Symbol.iterator in Object(t)) return function (t, e) {
          var n = [],
              r = !0,
              o = !1,
              i = void 0;

          try {
            for (var u, c = t[Symbol.iterator](); !(r = (u = c.next()).done) && (n.push(u.value), !e || n.length !== e); r = !0);
          } catch (t) {
            o = !0, i = t;
          } finally {
            try {
              !r && c.return && c.return();
            } finally {
              if (o) throw i;
            }
          }

          return n;
        }(t, e);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      },
          h = function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
        return t.map(function (t) {
          var n = e.filter(function (e) {
            return e.name === t.name;
          }),
              r = function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
            return t instanceof Array ? t : ["" + t];
          }(p(n, 1)[0].value);

          return s({}, t, {
            referenceValue: r
          });
        });
      },
          y = function () {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
          }
        }

        return function (e, n, r) {
          return n && t(e.prototype, n), r && t(e, r), e;
        };
      }(),
          v = function () {
        function t(e) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          !function (e, n) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }(this), this.root = e, this.name = e.name, this.config = n, this.rules = c(e.getAttribute(this.config.attributeName));
        }

        return y(t, [{
          key: "value",
          get: function () {
            return this.root.value;
          }
        }]), t;
      }();

      v.prototype.onShow = function () {
        this.root.name = this.name, this.config.onShow(this.root);
      }, v.prototype.onHide = function () {
        this.root.name = "", this.config.onHide(this.root), this.onReset();
      }, v.prototype.onReset = function () {
        this.root.value = "";
      }, v.prototype.onUpdate = function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
            n = t.target,
            r = (void 0 === n ? {} : n).name;
        (void 0 === r ? "" : r) !== this.name && this.rules && this[function t() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
          if (!e.length) return !0;
          var n = l(e, 1)[0],
              r = n.value,
              o = void 0 === r ? [] : r,
              i = n.referenceValue;
          return !!function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [],
                e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
            return !(t.length || !e.length) || t.some(function (t) {
              return -1 !== e.indexOf(t);
            });
          }(o, void 0 === i ? [] : i) && t(e.slice(1));
        }(h(this.rules, e)) ? "onShow" : "onHide"]();
      };

      var b = v,
          d = function (t) {
        function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
          return function (t, n) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this), function (t, e) {
            if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !e || "object" != typeof e && "function" != typeof e ? t : e;
          }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n));
        }

        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
        }(e, b), e;
      }(),
          g = function (t) {
        function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
          return function (t, n) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this), function (t, e) {
            if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !e || "object" != typeof e && "function" != typeof e ? t : e;
          }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n));
        }

        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
        }(e, b), e;
      }(),
          m = function () {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
          }
        }

        return function (e, n, r) {
          return n && t(e.prototype, n), r && t(e, r), e;
        };
      }(),
          w = function (t) {
        function e(t) {
          var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
          return function (t, n) {
            if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
          }(this), function (t, e) {
            if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !e || "object" != typeof e && "function" != typeof e ? t : e;
          }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n));
        }

        return function (t, e) {
          if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
          t.prototype = Object.create(e && e.prototype, {
            constructor: {
              value: t,
              enumerable: !1,
              writable: !0,
              configurable: !0
            }
          }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
        }(e, b), m(e, [{
          key: "onReset",
          value: function () {
            this.root.checked = !1;
          }
        }, {
          key: "value",
          get: function () {
            return "" + this.root.checked;
          }
        }]), e;
      }(),
          O = function () {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
          }
        }

        return function (e, n, r) {
          return n && t(e.prototype, n), r && t(e, r), e;
        };
      }(),
          j = [{
        Element: d,
        check: function (t) {
          return "INPUT" === t.tagName && "radio" !== t.type && "checkbox" !== t.type;
        }
      }, {
        Element: g,
        check: function (t) {
          return "TEXTAREA" === t.tagName;
        }
      }, {
        Element: w,
        check: function (t) {
          return "INPUT" === t.tagName && "checkbox" === t.type;
        }
      }, {
        Element: function (t) {
          function e(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
            return function (t, n) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this), function (t, e) {
              if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return !e || "object" != typeof e && "function" != typeof e ? t : e;
            }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n));
          }

          return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
          }(e, b), O(e, [{
            key: "onReset",
            value: function () {
              this.root.checked = !1;
            }
          }, {
            key: "value",
            get: function () {
              var t = document.querySelector('input[name="' + this.name + '"]:checked');
              if (t) return t.value;
            }
          }]), e;
        }(),
        check: function (t) {
          return "INPUT" === t.tagName && "radio" === t.type;
        }
      }, {
        Element: function (t) {
          function e(t) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
            return function (t, n) {
              if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }(this), function (t, e) {
              if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
              return !e || "object" != typeof e && "function" != typeof e ? t : e;
            }(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, n));
          }

          return function (t, e) {
            if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
            t.prototype = Object.create(e && e.prototype, {
              constructor: {
                value: t,
                enumerable: !1,
                writable: !0,
                configurable: !0
              }
            }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
          }(e, b), e;
        }(),
        check: function (t) {
          return "SELECT" === t.tagName;
        }
      }];

      function _(t) {
        if (Array.isArray(t)) {
          for (var e = 0, n = Array(t.length); e < t.length; e++) n[e] = t[e];

          return n;
        }

        return Array.from(t);
      }

      var E = function (t, e) {
        var n = e.map(function (t) {
          return t.name;
        });
        return [].concat(_(t), _(n));
      },
          P = function () {
        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
        return function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          return function () {
            return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).onUpdate(e, t);
          };
        };
      },
          k = Object.assign || function (t) {
        for (var e = 1; e < arguments.length; e++) {
          var n = arguments[e];

          for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
        }

        return t;
      },
          S = function () {
        function t(t, e) {
          for (var n = 0; n < e.length; n++) {
            var r = e[n];
            r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
          }
        }

        return function (e, n, r) {
          return n && t(e.prototype, n), r && t(e, r), e;
        };
      }();

      e.a = function () {
        return function () {
          function t(e) {
            var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            !function (e, n) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this), this.form = e, this.config = k({
              attributeName: r,
              formEvents: o,
              onShow: i,
              onHide: u
            }, n), this.init();
          }

          return S(t, [{
            key: "init",
            value: function () {
              if (this.form) {
                var t = function () {
                  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                      e = t.form,
                      n = t.attributeName,
                      r = void 0 === n ? "" : n,
                      o = t.config,
                      i = void 0 === o ? {} : o,
                      u = [].slice.call(e.querySelectorAll("[" + r + "]")).map(function (t) {
                    return t;
                  }),
                      a = u.map(function (t) {
                    return function (e) {
                      return c(e.getAttribute(t));
                    };
                  }(r)).reduce(E, []).map(function (t) {
                    return e.querySelector('[name="' + t + '"]');
                  });
                  return [].concat(_(u), _(a)).map(function (t) {
                    return f(t, j, i);
                  });
                }({
                  form: this.form,
                  attributeName: r,
                  config: this.config
                });

                o.forEach(function () {
                  var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                      e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [],
                      n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : function (t) {
                    return t;
                  };
                  return function () {
                    var r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    return t.addEventListener(r, function (t) {
                      return e.forEach(n(t));
                    });
                  };
                }(this.form, t, P(t))), t.forEach(P(t)());
              }
            }
          }]), t;
        }();
      };
    },
    "./src/index.js": function (t, e, n) {
      "use strict";

      n.r(e);
      var r = n("./src/app.js");
      e.default = Object(r.a)();
    }
  });
});